import { createContext } from 'preact';

export const StreamContextStatusChannel = createContext(null);
